<template>
    <div class="select-dente-interno" 
        :style="{ '--size': size + 'px' }"
        :data-tipo="detalhesDente.tipo"
        :data-lado="detalhesDente.lado" 
        :data-posicao="detalhesDente.posicao">
        <template v-if="tipoSelect === 'coroa'">
            <incisivoFacesCoroaSvg v-if="detalhesDente.tipo === 'anterior'" />
            <molarFacesCoroaSvg v-if="detalhesDente.tipo === 'posterior'" />
        </template>
        <template v-if="tipoSelect === 'raiz'">
            <incisivoFacesRaizSvg v-if="detalhesDente.tipo === 'anterior'" />
            <molarFacesRaizSvg v-if="detalhesDente.tipo === 'posterior'" />
        </template>
    </div>
</template>

<script>
import { selectDenteMixin } from '../../mixins/selectDenteMixin';
import incisivoFacesCoroaSvg from '../../lib/resources/svgs/incisivo_faces_coroa.svg';
import incisivoFacesRaizSvg from '../../lib/resources/svgs/incisivo_faces_raiz.svg';
import molarFacesCoroaSvg from '../../lib/resources/svgs/molar_faces_coroa.svg';
import molarFacesRaizSvg from '../../lib/resources/svgs/molar_faces_raiz.svg';

export default {
    name: 'selectFacesDente',
    components: {
        incisivoFacesCoroaSvg,
        incisivoFacesRaizSvg,
        molarFacesCoroaSvg,
        molarFacesRaizSvg,
    },
    mixins: [selectDenteMixin],
    props: {
        /**
         * 'coroa' ou 'raiz'
         */
        tipoSelect: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
@import '../../styles/_select_dente_interno.css';
</style>